/**
 * Shared color constants for JS contexts (recharts, canvas/d3, inline styles during migration).
 * For DOM elements, prefer Tailwind classes instead of these constants.
 */
export const colors = {
  // Primary
  primary: '#3498db',
  primaryDark: '#2980b9',
  primaryLight: '#e8f4fd',

  // Text
  text: '#2c3e50',
  textSecondary: '#495057',
  textMuted: '#6c757d',
  textLight: '#95a5a6',

  // Backgrounds
  background: '#f8f9fa',
  backgroundAlt: '#f0f4f8',
  white: '#ffffff',

  // Borders
  border: '#e9ecef',
  borderLight: '#dee2e6',

  // Status
  success: '#27ae60',
  successDark: '#218838',
  warning: '#e67e22',
  warningLight: '#f39c12',
  danger: '#e74c3c',
  dangerDark: '#c0392b',

  // Links
  link: '#3498db',

  // Tags (PersonPage specific)
  tagBlue: '#ebf4ff',
  tagBlueBorder: '#bee3f8',
  tagBlueText: '#2b6cb0',
  tagYellow: '#fefcbf',
  tagYellowBorder: '#f6e05e',
  tagYellowText: '#975a16',
  tagGray: '#4a5568',
};

// CTU company-type colors (used by recharts + inline styles).
export const CTU_SPINOFF_COLOR = '#9F86C0';
export const CTU_STARTUP_COLOR = '#F2A88C';
